// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"96e14074","977":"cc6b2b46"}[chunkId] + ".chunk.js";
};